// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bron-update {
  background-color: #f6f6f6;
  padding-block: 24px;
}

.bron-update__container {
  background-color: #FFFFFF;
  border-radius: 8px;
}

.bron-update__title {
  padding: 24px;
  color: #323232;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/modules/bron/BronUpdate.scss","webpack://./src/modules/bron/BronUpdate.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;ACCrB;;ADCE;EACE,yBAAyB;EACzB,kBAAkB;ACEtB;;ADCE;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;ACEvB","sourcesContent":[".bron-update {\n  background-color: #f6f6f6;\n  padding-block: 24px;\n\n  &__container {\n    background-color: #FFFFFF;\n    border-radius: 8px;\n  }\n\n  &__title {\n    padding: 24px;\n    color: #323232;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n}",".bron-update {\n  background-color: #f6f6f6;\n  padding-block: 24px;\n}\n\n.bron-update__container {\n  background-color: #FFFFFF;\n  border-radius: 8px;\n}\n\n.bron-update__title {\n  padding: 24px;\n  color: #323232;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
